import { LoadingOutlined } from "@ant-design/icons";

export default function LoadingIcon() {
  return <LoadingOutlined style={{ fontSize: 18 }} spin />;
}
